<script lang="ts">
    import { onMount } from 'svelte'

    import CodeMirror from 'codemirror/lib/codemirror.js'

    // import 'codemirror/addon/mode/overlay'
    // import 'codemirror/mode/meta'
    // import 'codemirror/mode/markdown/markdown'
    // import 'codemirror/mode/gfm/gfm'
    // import 'codemirror/mode/javascript/javascript'
    // import 'codemirror/mode/xml/xml'
    // import 'codemirror/mode/jinja2/jinja2'
    // import 'codemirror/mode/htmlmixed/htmlmixed'

    interface Props {
        class?: string
        editor?: any
        options?: any
        value: string
        style?: string
        setEditor?: (e: any) => void
        setValue?: (e: string) => void
    }

    let { class: classes = '', editor = $bindable(), options = {}, value = $bindable(), style = '', setEditor, setValue }: Props = $props()

    let element: HTMLDivElement | undefined = $state()

    onMount(() => createEditor(options))

    function createEditor(options) {
        if (!window) return
        if (!element) return
        if (editor) element.innerHTML = ''
        editor = CodeMirror(element, { ...options, value })
        if (setEditor) setEditor(editor)

        editor.on('change', () => {
            value = editor.getValue()
            if (setValue) {
                setValue(value)
            }
        })

        // Fixes:
        // 1. https://github.com/codemirror/CodeMirror/issues/1351 -> add scrollInfo to scroll back to where it was;
        // 2. setCursor, add scroll:false. Else every editor in the page scroll the window
        //    to them, which is annoying as fuck.

        const pos = editor.getCursor()
        const scrollInfo = editor.getScrollInfo()
        editor.setValue(value ? value : '')
        editor.setCursor(pos, null, { scroll: false })
        editor.scrollTo(scrollInfo.left, scrollInfo.top)

        Object.entries(options).forEach(([key, value]) => {
            editor.setOption(key, value)
        })
    }
</script>

{#if value != null}
    <div bind:this={element} class={classes} {style}></div>
{/if}
